import React, { useEffect, useState, useRef, useContext } from "react";
import { Redirect, useHistory } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import InputMask from "react-input-mask";
import CurrencyInput from "react-currency-input";
import { URLBunge } from "./Componentes/Config";
import Button from "@material-ui/core/Button";
import {
  LogAcesso,
  AlertForm,
  AlertRedirect,
  MascaraCNPJ,
  DecimalReal,
} from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  BtVoltar,
  BtFiltroMesAtivo,
  BtFiltroMes,
  ItemListaBusca,
  BgModal,
  ModalEvento,
  TextoDescPesquisa,
  CampoFormCadastro,
  BtFiltrar,
  ListaFiltro,
  ItemListaAtendimentos,
  SolicitanteCliente,
  TipoAtendimento,
  BtFecharAtendimento,
  RespostaForm,
  BtVerRelatorioCompleto,
  BtNovoAtendimento,
} from "./Estilos";

import IcoBusca from "./Images/ico_search_branco.png";
import ImgBtSetaVoltar from "./Images/BtSeta.png";

function AcademiaFormularioListaTecnico(props) {
  const history = useHistory();
  const [Loading, setLoading] = useState(true);
  const { register, handleSubmit, errors, control, setValue } = useForm();

  const [NomeEvento, setNomeEvento] = useState("Minha Bunge Vendas");
  const [Token, setToken] = useState(localStorage.getItem("c_token"));
  const [IdUser, setIdUser] = useState(localStorage.getItem("id_tb_user"));
  const [CPFUser, setCPFUser] = useState(localStorage.getItem("c_cpf"));
  const [Cargo, setCargo] = useState(localStorage.getItem("c_cargo"));
  const [LinkNavegacao, setLinkNavegacao] = useState("");

  useEffect(() => {
    if (Token === null) {
      history.push({ pathname: "/", state: {} });
    } else {
      LogAcesso(Token, "Academia - Requisições de Atendimento - Vendedor");
    }
    setTimeout(() => {
      console.log(ListaStatus);
    }, 1000);
  }, []);

  const [ListaRequisicoes, setListaRequisicoes] = useState([]);
  const [ListaStatus, setListaStatus] = useState([]);

  useEffect(() => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(`${URLBunge}/api/Requisicoes/ListaStatus`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result.listaStatus[1].idStatus);
        ListarRequisicoes(result.listaStatus[1].idStatus);
        setTipoSelecionado2(result.listaStatus[1].idStatus);

        for (let i = 0; i < result.listaStatus.length; i = i + 1) {
          if (result.listaStatus[i].idStatus !== 1) {
            if (result.listaStatus[i].descricao == "Encaminhada p/ Técnico") {
              setListaStatus((ListaStatus) => [
                ...ListaStatus,
                {
                  value: result.listaStatus[i].idStatus,
                  label: "Encaminhada pelo coordenador",
                },
              ]);
            } else {
              setListaStatus((ListaStatus) => [
                ...ListaStatus,
                {
                  value: result.listaStatus[i].idStatus,
                  label: result.listaStatus[i].descricao,
                },
              ]);
            }
          }
        }
      })
      .catch((error) => console.log("error", error));
  }, []);

  function ListarRequisicoes(item) {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(
      `${URLBunge}/api/Requisicoes/ListarRequisicoes/` + item,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        // setListaRequisicoes(result.listaRequisicoes);
        setListaRequisicoes([]);
        for (let i = 0; i < result.listaRequisicoes.length; i = i + 1) {
          if (
            result.listaRequisicoes[i].tecnicoId == IdUser ||
            result.listaRequisicoes[i].entidadeId == IdUser
          ) {
            setListaRequisicoes((listaRequisicoes) => [
              ...listaRequisicoes,
              {
                idRequisicao: result.listaRequisicoes[i].idRequisicao,
                solicitante: result.listaRequisicoes[i].solicitante,
                cliente: result.listaRequisicoes[i].cliente,
                tipoAtendimento: result.listaRequisicoes[i].tipoAtendimento,
                detalhes: result.listaRequisicoes[i].detalhes,
                produto: result.listaRequisicoes[i].produto,
                dataVisita: result.listaRequisicoes[i].dataVisita,
                potencialCompra: result.listaRequisicoes[i].potencialCompra,
                cnpj: result.listaRequisicoes[i].cnpj,
                sap: result.listaRequisicoes[i].sap,
                rua: result.listaRequisicoes[i].rua,
                numero: result.listaRequisicoes[i].numero,
                cep: result.listaRequisicoes[i].cep,
                bairro: result.listaRequisicoes[i].bairro,
                cidade: result.listaRequisicoes[i].cidade,
                uf: result.listaRequisicoes[i].uf,
                caminhoFoto: result.listaRequisicoes[i].caminhoFoto,
                caminhoArquivo: result.listaRequisicoes[i].caminhoArquivo,
                nomeTecnico: result.listaRequisicoes[i].nomeTecnico,
                checkIn: result.listaRequisicoes[i].checkIn,
                checkOut: result.listaRequisicoes[i].checkOut,
                bonificacao: result.listaRequisicoes[i].bonificacao,
                gastosInsumo: result.listaRequisicoes[i].gastosInsumo,
                gastosProdutosInternos:
                  result.listaRequisicoes[i].gastosProdutosInternos,
                gastosDeslocamento:
                  result.listaRequisicoes[i].gastosDeslocamento,
                gastosAlimentacao: result.listaRequisicoes[i].gastosAlimentacao,
                gastosHospedagem: result.listaRequisicoes[i].gastosHospedagem,
                gastosDiversos: result.listaRequisicoes[i].gastosDiversos,
                pessoasTreinadas: result.listaRequisicoes[i].pessoasTreinadas,
                observacao: result.listaRequisicoes[i].observacao,
                tecnicoId: result.listaRequisicoes[i].tecnicoId,
                efetuouVendas: result.listaRequisicoes[i].efetuouVendas,
                motivo: result.listaRequisicoes[i].motivo,
                statusPesquisaFinal:
                  result.listaRequisicoes[i].statusPesquisaFinal,
                telefoneCliente: result.listaRequisicoes[i].telefoneCliente,
                telefoneVendedor: result.listaRequisicoes[i].telefoneVendedor,
                tipoUrgencia: result.listaRequisicoes[i].tipoUrgencia,
              },
            ]);
          }
        }
        setLoading(false);
      })
      .catch((error) => console.log("error", error));
  }

  const TipoSelecionadoInput = useRef();
  const [TipoSelecionado, setTipoSelecionado] = useState(0);
  const [TipoSelecionado2, setTipoSelecionado2] = useState(0);
  function MudaLista(Tipo) {
    setTipoSelecionado(Tipo);
    setTipoSelecionado2(Tipo);
    if (Tipo === 0) {
      LogAcesso(Token, "Academia - Requisições de Atendimento - ABERTOS");
    }
    if (Tipo === 1) {
      LogAcesso(Token, "Academia - Requisições de Atendimento - EM ANDAMENTO");
    }
    if (Tipo === 2) {
      LogAcesso(Token, "Academia - Requisições de Atendimento - FINALIZADOS");
    }
  }

  function MudaFiltro() {
    setListaRequisicoes([]);
    if (TipoSelecionado === 0) {
      MudaLista(2);
      ListarRequisicoes(2);
    } else {
      MudaLista(TipoSelecionado);
      ListarRequisicoes(TipoSelecionado);
    }
    setLoading(true);
  }

  function FinalizarRequisicao(idRequisicao) {
    history.push({
      pathname: "/AcademiaFormularioAtendimentoTecnico",
      state: {
        idRequisicao: idRequisicao,
      },
    });
    setTimeout(() => {
      setListaRequisicoes([]);
    }, 300);
  }

  const renderListaRequisicoes = (item, index) => {
    console.log("***", item);
    return (
      <>
        <ItemListaAtendimentos key={index}>
          {item.tipoUrgencia && (
            <>
              <SolicitanteCliente>Urgência do atendimento:</SolicitanteCliente>

              <Button
                style={{
                  backgroundColor:
                    item.tipoUrgencia == "Amarelo"
                      ? "yellow"
                      : item.tipoUrgencia == "Verde"
                      ? "green"
                      : "red",
                  marginBottom: 5,
                  width: "100%",
                  color: "#000000",
                }}
              >
                {item.tipoUrgencia == "Amarelo"
                  ? "Moderado"
                  : item.tipoUrgencia == "Verde"
                  ? "Sem urgência"
                  : "Crítico"}
              </Button>
            </>
          )}
          <SolicitanteCliente>
            {" "}
            Solicitante: <div>{item.solicitante}</div>{" "}
          </SolicitanteCliente>
          <SolicitanteCliente>
            {" "}
            Cliente: <div>{item.cliente}</div>
            {`CNPJ: ${MascaraCNPJ(item.cnpj)}`}
            <br />
            {`SAP: ${item.sap}`}
          </SolicitanteCliente>
          <TipoAtendimento>
            {" "}
            Endereço:{" "}
            <div>
              {item.rua}, {item.numero}
              <br />
              {item.bairro}, {item.cidade}, {item.uf}
              <br />
              {item.cep}
            </div>{" "}
          </TipoAtendimento>
          <TipoAtendimento>
            {" "}
            Data da visita:{" "}
            <div>
              {item.dataVisita.substr(8, 2)}/{item.dataVisita.substr(5, 2)}/
              {item.dataVisita.substr(0, 4)} - {item.dataVisita.substr(11, 2)}:
              {item.dataVisita.substr(14, 2)}
            </div>{" "}
          </TipoAtendimento>
          <TipoAtendimento>
            {" "}
            Tipo de atendimento: <div>{item.tipoAtendimento}</div>{" "}
          </TipoAtendimento>
          <TipoAtendimento>
            {" "}
            Produto: <div>{item.produto}</div>{" "}
          </TipoAtendimento>
          <TipoAtendimento>
            {" "}
            Potencial de compra: <div>{item.potencialCompra} KG</div>{" "}
          </TipoAtendimento>
          {item.telefoneVendedor && (
            <>
              <TipoAtendimento>
                {" "}
                Telefone do Vendedor: <div>{item.telefoneVendedor} </div>{" "}
              </TipoAtendimento>
              <TipoAtendimento>
                {" "}
                Telefone do Cliente: <div>{item.telefoneCliente} </div>{" "}
              </TipoAtendimento>
            </>
          )}

          {TipoSelecionado2 == 2 ? (
            <BtFecharAtendimento
              onClick={() => FinalizarRequisicao(item.idRequisicao)}
            >
              FINALIZAR ATENDIMENTO
            </BtFecharAtendimento>
          ) : null}

          {TipoSelecionado2 == 3 ? (
            <>
              {item.checkIn !== null ? (
                <TipoAtendimento>
                  {" "}
                  Check-in:{" "}
                  <div>
                    {item.checkIn.substr(8, 2)}/{item.checkIn.substr(5, 2)}/
                    {item.checkIn.substr(0, 4)} - {item.checkIn.substr(11, 2)}:
                    {item.checkIn.substr(14, 2)}
                  </div>{" "}
                </TipoAtendimento>
              ) : null}

              {item.checkOut !== null ? (
                <TipoAtendimento>
                  {" "}
                  Check-out:{" "}
                  <div>
                    {item.checkOut.substr(8, 2)}/{item.checkOut.substr(5, 2)}/
                    {item.checkOut.substr(0, 4)} - {item.checkOut.substr(11, 2)}
                    :{item.checkOut.substr(14, 2)}
                  </div>{" "}
                </TipoAtendimento>
              ) : null}

              <TipoAtendimento>
                {" "}
                Detalhes: <div>{item.detalhes}</div>{" "}
              </TipoAtendimento>
              <TipoAtendimento>
                {" "}
                Observação: <div>{item.observacao}</div>{" "}
              </TipoAtendimento>
              <TipoAtendimento>
                {" "}
                Pessoas treinadas: <div>{item.pessoasTreinadas}</div>{" "}
              </TipoAtendimento>
              <TipoAtendimento>
                {" "}
                Bonificação:{" "}
                <div>{item.bonificacao === true ? "SIM" : "NÃO"}</div>{" "}
              </TipoAtendimento>
              <TipoAtendimento>
                {" "}
                Gastos:
                <div>
                  Insumos: {DecimalReal(item.gastosInsumo)}
                  <br />
                  Produtos internos: {DecimalReal(item.gastosProdutosInternos)}
                  <br />
                  Deslocamento: {DecimalReal(item.gastosDeslocamento)}
                  <br />
                  Alimentação: {DecimalReal(item.gastosAlimentacao)}
                  <br />
                  Hospedagem: {DecimalReal(item.gastosHospedagem)}
                  <br />
                  Outros: {DecimalReal(item.gastosDiversos)}
                  <br />
                  TOTAL:{" "}
                  {DecimalReal(
                    item.gastosProdutosInternos +
                      item.gastosDeslocamento +
                      item.gastosAlimentacao +
                      item.gastosHospedagem +
                      item.gastosDiversos
                  )}
                </div>
              </TipoAtendimento>
            </>
          ) : null}
        </ItemListaAtendimentos>
      </>
    );
  };

  useEffect(() => {
    if (Cargo == "2653") {
      setLinkNavegacao("/AcademiaFormularioCalendario");
    } else {
      setLinkNavegacao("/home");
    }
  }, []);

  return (
    <>
      <CabecalhoPagina NomeEvento={NomeEvento} />
      {Loading === true ? <Carregando /> : null}

      <BackgroundImg Background={""} BackgroundMob={""} bgcolor={"#FFFFFF"}>
        <ColunaRegras>
          <div className={"AreaColunaRegras"}>
            <TitNoticias>Lista de Atendimentos</TitNoticias>
            <Clear />

            <BtVoltar
              onClick={() =>
                history.push({ pathname: LinkNavegacao, state: {} })
              }
              style={{ marginLeft: "auto", marginRight: "auto" }}
            >
              <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
            </BtVoltar>
            <Clear />

            <br />
            <TextoDescPesquisa>
              Lista de requisições de atendimento:
            </TextoDescPesquisa>
            <Clear />

            <Clear />

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ListaFiltro>
                <select
                  name={"c_estado"}
                  id={"c_estado"}
                  ref={register}
                  onChange={(event) => setTipoSelecionado(event.target.value)}
                >
                  {/* <option value={0} disabled selected>Selecione</option> */}
                  {ListaStatus.map((item, index) => {
                    return (
                      <>
                        {" "}
                        <option value={item.value}>{item.label}</option>{" "}
                      </>
                    );
                  })}
                </select>
              </ListaFiltro>

              <BtFiltrar onClick={() => MudaFiltro()}>Filtrar</BtFiltrar>
            </div>

            <Clear />
            <br />

            <div style={{ flex: 1 }}>
              {ListaRequisicoes.length == 0 ? (
                <div>Carregando...</div>
              ) : (
                ListaRequisicoes.map((item, key) => {
                  return renderListaRequisicoes(item, key);
                })
              )}
            </div>
          </div>
        </ColunaRegras>

        <MenuPrinc Pagina="Pesquisas" />
      </BackgroundImg>
    </>
  );
}

export default AcademiaFormularioListaTecnico;
